import { ADD_FILE_FOR_TASK, ADD_FILE_FOR_TASK_FAIL, ADD_FILE_FOR_TASK_SUCCESS } from "./actionTypes";

export const addFileforTeamTask = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_FILE_FOR_TASK,
  payload: { data, onSuccess, onError },
});

export const addFileforTeamTaskSuccess = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_FILE_FOR_TASK_SUCCESS,
  payload: { data, onSuccess, onError },
});

export const addFileforTeamTaskFail = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_FILE_FOR_TASK_FAIL,
  payload: { data, onSuccess, onError },
});
